<ui-card class="invoice-history" [class.loading]="!(subscriptions?.length && invoices?.length)">
    <app-segment-header title="{{ 'settings.invoice-overview.header' | translate }}">
        <ui-button class="buttons" type="link" url="invoices">
            {{ 'settings.invoice-overview.invoiceHistoryButton' | translate }}
        </ui-button></app-segment-header
    >
    <div class="invoice" *ngIf="upcomingInvoice">
        <div>{{ 'settings.invoice-overview.nextPaymentHeader' | translate }}</div>
        <div>{{ upcomingInvoice.amountDue | i18nNum: '$' }}</div>
        <div>{{ 'settings.invoice-overview.nextBillingCycleHeader' | translate }}</div>
    </div>
    <ng-container *ngFor="let subscription of subscriptions">
        <div class="invoice" *ngIf="subscription.latestInvoice && getInvoice(subscription.latestInvoice)">
            <div>{{ 'settings.invoice-overview.lastPaymentHeader' | translate }}</div>
            <div>{{ getInvoice(subscription.latestInvoice)?.amountPaid | i18nNum: '$' }}</div>
            <div>{{ getInvoice(subscription.latestInvoice).periodEnd | appDate: 'mediumDate' }}</div>
        </div>
    </ng-container>
</ui-card>
